export function loggedIn() {
    return !!localStorage.authToken
}

export function requireAuth(nextState, replace) {
    if (!loggedIn()) {
        replace({
            pathname: '/login',
            state: { nextPathname: nextState.location.pathname }
        })
    }
}



// WEBPACK FOOTER //
// ./src/auth.js